@if (threadHeader$ | async; as thread) {
  <div
    placement="top"
    class="flex justify-between font-main text-base items-center p-1.5 mb-1.5 cursor-pointer hover:bg-navy-40 rounded-md"
    [ngbTooltip]="doesOverflowWidth && tooltipTemplate"
  >
    <div class="flex items-center">
      <app-commenting-user-logo
        [userId]="thread.initiatorId"
        [fallbackUserName]="thread.initiatorName"
      ></app-commenting-user-logo>
      <span #threadBody class="thread-body" [innerHTML]="sanitizeHtml(thread.body)"></span>
    </div>
    <span class="text-navy-70 whitespace-nowrap">
      {{ buildTranslationKey('repliesText') | translate: { repliesAmount: repliesCount$ | async } }}
    </span>
    <ng-template #tooltipTemplate>
      <div>
        <p>{{ thread.initiatorName }}</p>
        <p [innerHTML]="sanitizeHtml(thread.body)"></p>
      </div>
    </ng-template>
  </div>
}
